/**
 * Scroll Reveal Observer
 * Watches all elements with [data-scroll-reveal] and adds .is-visible
 * when they enter the viewport. Fires once per element.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function observe(root) {
    var elements = (root || document).querySelectorAll('[data-scroll-reveal]:not(.is-visible)');
    if (!elements.length) return;
    elements.forEach(function (el) { observer.observe(el); });
  }

  var isMobile = window.innerWidth <= 768;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.getAttribute('data-scroll-delay');
        if (delay) el.style.animationDelay = delay + 'ms';
        el.classList.add('is-visible');
        observer.unobserve(el);
      });
    },
    { threshold: isMobile ? 0.05 : 0.15, rootMargin: isMobile ? '0px 0px 80px 0px' : '0px 0px -50px 0px' }
  );

  observe();

  /* Re-observe when the Theme Editor loads a new section */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
